var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var SvgHhShape = function SvgHhShape(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 225 225"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "hh-shape_svg__cls-1",
    d: "M76.63 192 33 148.37a7.06 7.06 0 0 1-2.06-5V81.62a7.06 7.06 0 0 1 2.06-5L76.63 33a7.06 7.06 0 0 1 5-2.06h61.76a7.06 7.06 0 0 1 5 2.06L192 76.63a7.06 7.06 0 0 1 2.06 5v61.76a7.06 7.06 0 0 1-2.06 5L148.37 192a7.06 7.06 0 0 1-5 2.06H81.62a7.06 7.06 0 0 1-4.99-2.06Z",
    "data-name": "Layer 4"
  })));
};

export default SvgHhShape;